import { useState, useEffect } from "react";
import swal from 'sweetalert2';
import { getVendorFeeCalendarByVendorID, updateVendorFeeCalendarStatus } from "../api/vendorAPI";
import no_fee from '../../assets/images/no_fee_calendar_placeholder.svg';

// Backend dates arrive as ISO strings — render as DD-MMM-YYYY
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const fmtDate = (d) => {
    if (!d) return '-';
    const dt = new Date(d);
    if (isNaN(dt)) return '-';
    return `${String(dt.getDate()).padStart(2, '0')}-${MONTHS[dt.getMonth()]}-${dt.getFullYear()}`;
};

// Total for a (TypeID, Hole) combination from a calendar's Fees[].
//   TypeID: 1 = Weekday, 2 = Weekend ;  Hole: 9 / 18
const totalFor = (calendar, typeID, hole) => {
    const fee = (calendar.Fees || []).find((f) => f.TypeID === typeID && Number(f.Hole) === hole);
    // return fee ? Number(fee.Total).toFixed(2) : '-';
    return fee ? Number(fee.Total).toFixed(2) : '-';
};

// "9h: ₹.. · 18h: ₹.." summary for a type.
// const totalForType = (calendar, typeID) => `9h: ${totalFor(calendar, typeID, 9)} · 18h: ${totalFor(calendar, typeID, 18)}`;
// const totalForType = (calendar, typeID, hole) => `9h: ${totalFor(calendar, typeID, 9)} · 18h: ${totalFor(calendar, typeID, 18)}`;


// The Add/Edit modal lives in the parent (VendorFeeCalendar.js). This tab
// requests add/edit through onAdd / onEdit, and refetches whenever the parent
// bumps `refreshToken` (i.e. after a successful save).
const VendorFeeCalendarTab = ({ vendorID, onAdd, onEdit, refreshToken }) => {

    const [calendars,    setCalendars]    = useState([]);
    const [isLoading,    setIsLoading]    = useState(false);

    useEffect(() => {
        if (vendorID) fetchCalendars();
    }, [vendorID, refreshToken]);

    const fetchCalendars = async () => {
        setIsLoading(true);
        try {
            const data = await getVendorFeeCalendarByVendorID(vendorID);
            // Backend already sorts (active first, StartDate desc) — re-apply defensively
            const sorted = (data || []).sort((a, b) => {
                if (!!b.IsActive !== !!a.IsActive) return (b.IsActive ? 1 : 0) - (a.IsActive ? 1 : 0);
                return new Date(b.StartDate) - new Date(a.StartDate);
            });
            setCalendars(sorted);
        } catch (err) {
            swal.fire({ icon: 'error', titleText: err.message });
        } finally {
            setIsLoading(false);
        }
    };

    // const toggleStatus = async (calendar) => {
    //     const nextStatus = calendar.IsActive ? 0 : 1;
    //     const result = await swal.fire({
    //         icon               : 'warning',
    //         titleText          : nextStatus ? 'Activate this calendar?' : 'Deactivate this calendar?',
    //         showCancelButton   : true,
    //         confirmButtonText  : nextStatus ? 'Activate' : 'Deactivate',
    //         cancelButtonText   : 'Cancel',
    //         buttonsStyling     : false,
    //         confirmButtonClass : `btn ${nextStatus ? 'btn-success' : 'btn-secondary'} margin-r5`,
    //         cancelButtonClass  : 'btn btn-outline-secondary',
    //     });
    //     if (!result.isConfirmed) return;

    //     try {
    //         await updateVendorFeeCalendarStatus(calendar.ID, nextStatus);
    //         fetchCalendars();
    //         swal.fire({
    //             toast             : true,
    //             icon              : 'success',
    //             titleText         : nextStatus ? 'Calendar activated.' : 'Calendar deactivated.',
    //             position          : 'bottom-end',
    //             showConfirmButton : false,
    //             timer             : 1500,
    //             animation         : false,
    //             customClass       : { popup: 'margin-20' },
    //         });
    //     } catch (err) {
    //         swal.fire({ icon: 'error', titleText: err.message });
    //     }
    // };

    return (
        <div className="margin-t10">

            {/* Add Calendar */}
            <div className="row margin-b10">
                <div className="col-12 text-right">
                    <button type="button" className="btn btn-brand btn-sm d-inline-block" onClick={() => onAdd && onAdd()}>
                        <i className="la la-plus"></i> Add Calendar
                    </button>
                </div>
            </div>

            {/* Loading */}
            {isLoading && (
                <div className="text-center padding-tb20">
                    <div className="kt-spinner kt-spinner--brand kt-spinner--lg margin-auto"></div>
                </div>
            )}

            {/* Table */}
            {!isLoading && (
                <div className="table-responsive" style={{ maxHeight: 420, overflowY: 'auto' }}>
                    <table className="table table-striped table-bordered table-hover table-vendor-fee py-3 table-sm margin-b0">
                        <thead style={{ position: 'sticky', top: 0, zIndex: 1, background: '#fff' }}>
                            <tr>
                                <th>Name</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th className="text-right"> 18h Weekday </th>
                                <th className="text-right"> 18h Weekend </th>
                                <th className="text-right"> 9h Weekday</th>
                                <th className="text-right"> 9h Weekend </th>
                                <th className="text-center"> Status</th>
                                {/* <th>Comment</th> */}
                                {/* <th>Created By</th> */}
                                {/* <th>Created</th> */}
                                <th className="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {calendars.length === 0 ? (
                                <tr>
                                    <td colSpan={10} className="text-center padding-tb30" style={{background:"white"}}>
                                        {/* <span className="kt-font-bold kt-font-lg text-muted">No fee calendars.</span> */}
                                        <img src={no_fee} height={200} />
                                    </td>
                                </tr>
                            ) : calendars.map((c) => (
                                <tr key={c.ID}>
                                    <td >{c.Name}</td>
                                    <td>{fmtDate(c.StartDate)}</td>
                                    <td>{fmtDate(c.EndDate)}</td>
                                    {/* <td className="text-right">{totalForType(c, 1)}</td>
                                    <td className="text-right">{totalForType(c, 2)}</td> */}
                                    <td className="text-right">{totalFor(c, 1,18)}</td>
                                    <td className="text-right">{totalFor(c, 2,18)}</td>
                                    <td className="text-right">{totalFor(c, 1,9)}</td>
                                    <td className="text-right">{totalFor(c, 2,9)}</td>
                                    <td className="text-center">
                                        {c.IsActive
                                            ? <span className="kt-badge kt-badge--success kt-badge--pill padding-20 padding-tb5">Active</span>
                                            : <span className="kt-badge kt-badge--grey kt-badge--pill padding-25 padding-tb5">Inactive</span>
                                        }
                                    </td>                                  
                                    <td className="text-center" style={{ width:"80px", whiteSpace: 'nowrap' }}>
                                        {/* <button type="button" class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs mr-3"
                                            data-toggle="kt-popover"  data-trigger="hover click" 
                                            data-placement="left" data-original-title="Comments" 
                                            data-content={`${c.Comment}`}
                                        >
                                            <i class="fa fa-info"></i>
                                        </button> */}

                                        <button
                                            type="button"
                                            className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r5"
                                            title="Edit"
                                            onClick={() => onEdit && onEdit(c)}
                                        >
                                            <i className="flaticon2-edit"></i>
                                        </button>
                                        {/* <button
                                            type="button"
                                            className={`btn btn-elevate btn-circle btn-icon btn-xs ${c.IsActive ? 'btn-outline-secondary' : 'btn-outline-success'}`}
                                            title={c.IsActive ? 'Deactivate' : 'Activate'}
                                            onClick={() => toggleStatus(c)}
                                        >
                                            <i className={c.IsActive ? 'la la-toggle-off' : 'la la-toggle-on'}></i>
                                        </button> */}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default VendorFeeCalendarTab;
